module.exports = __webpack_public_path__ + "static/media/reading.0733d271.png";